module.exports = __webpack_public_path__ + "static/media/loading.2f83a08d.gif";